import styled from 'styled-components';
import { useTranslation } from 'next-i18next';
import useCountdownTimer from '../../../hooks/CountdownTimer';

interface CounterType {
  displayValue?: string;
  label: string;
}

interface CountdownTimerProps {
  endDate: string;
}

const Counter = ({ displayValue, label }: CounterType) => (
  <>
    <CounterStyled>
      <p className="counter-value">{displayValue}</p>
      <p className="counter-label">{label}</p>
    </CounterStyled>
    <span className="counter-separator">:</span>
  </>
);

const CountdownTimer = ({ endDate }: CountdownTimerProps) => {
  const { t } = useTranslation('common');

  const { countdownTime } = useCountdownTimer(endDate);

  return !countdownTime.hasEnded ? (
    <CounterWrapper>
      <Counter displayValue={countdownTime.days} label={t('days')} />
      <Counter
        displayValue={(Number(countdownTime.hours!) + 1).toString()}
        label={t('hours')}
      />
    </CounterWrapper>
  ) : (
    <></>
  );
};

const CounterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  direction: ltr;

  .counter-separator {
    color: #fff;
    font-family: materialRegular;
    font-size: 14px;
    padding: 6px 8px;
  }

  .counter-separator:last-child {
    display: none;
  }
  @media only screen and (min-width: ${props =>
      props.theme.breakPoints.mobile.min}) and (max-width: ${props =>
      props.theme.breakPoints.tablet.max}) {
    font-size: 30px;

    .counter-separator {
      padding: 8px;
    }
  }
`;

const CounterStyled = styled.div`
  width: 100%;
  min-width: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .counter-value {
    font-family: materialBold;
    color: #fff;
    font-size: 26px;
  }

  .counter-label {
    font-family: materialLight;
    font-size: ${props => props.theme.font.sizes.xs};
  }

  @media only screen and (min-width: ${props =>
      props.theme.breakPoints.mobile.min}) and (max-width: ${props =>
      props.theme.breakPoints.tablet.max}) {
    min-width: 0;
    .counter-value {
      font-family: materialBold;
      font-size: 30px;
    }
  }

  @media only screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.min}) {
    .counter-label {
      font-size: 12px;
    }
  }
`;

export default CountdownTimer;
